export default __webpack_public_path__ + "static/skillsDesignMobile-4cfab7451ed30d24da02e92f7e71afeb.mp4";